export var mapApiError = function (error) {
    var _a, _b;
    var data = (_a = error.response) === null || _a === void 0 ? void 0 : _a.data;
    var status = (data === null || data === void 0 ? void 0 : data.statusCode) || ((_b = error.response) === null || _b === void 0 ? void 0 : _b.status);
    if (status === 404) {
        return { field: "username", message: "errorMessages.userNotFound" };
    }
    if (status === 403) {
        return {
            field: "username",
            message: (data === null || data === void 0 ? void 0 : data.message) === "RECIPIENT_KYC_NOT_VERIFIED"
                ? "errorMessages.kycNotVerified"
                : "errorMessages.accessDenied",
        };
    }
    return { field: "general", message: "errorMessages.serverError" };
};
